import React from 'react';
import {makeStyles} from '@material-ui/core';
import PaperCustom from "../../common/PaperCustom";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import FlipComponent from "./flipComponent/FlipComponent";

const useStyles = makeStyles(theme => ({
    subtitle1: {
        textAlign: 'center',
        [theme.breakpoints.down('sm')]: {
            fontSize: 15,
            lineHeight: '20px',
        },
    },
    offerContainer: {
        margin: '50px 0px',
        [theme.breakpoints.down('sm')]: {
            margin: '30px 0px',
        },
    },
    noWrap: {
        whiteSpace: "nowrap"
    },
}));

function Offer() {
    const classes = useStyles();

    return (
        <PaperCustom title={"NOTRE OFFRE DE SERVICES"} src={'/image/offer/IconeChecked.png'} alt={"Logo validé"}>
            <Typography variant={"subtitle1"} className={classes.subtitle1}>
                Nous vous accompagnons dans l’amélioration continue de votre stratégie cybersécurité en travaillant
                avec des technologies leaders dans les domaines <span className={classes.noWrap}>suivants :</span>
            </Typography>
            <Grid container justifyContent="center" className={classes.offerContainer}>
                <Grid item xs={12} lg={6} xl={4} style={{marginTop: 20, marginBottom: 20}}>
                    <FlipComponent
                        img={"/image/offer/IconeSecurite.png"}
                        title={<>Sécurité<br/>du poste de travail</>}
                        options={[
                            "Accès direct à votre Chef de projet",
                            "RDV de pilotage semestriels",
                            "Gestion des alertes EDR",
                            "Campagnes de tests semestrielles"
                        ]}
                        logos={[
                            "/image/offer/IconeProfil.png",
                            "/image/offer/IconeAgenda.png",
                            "/image/offer/IconeCare.png",
                            "/image/offer/IconeLoupe.png",
                        ]}
                    />
                </Grid>
                <Grid item xs={12} lg={6} xl={4} style={{marginTop: 20, marginBottom: 20}}>
                    <FlipComponent
                        title={<>Sécurité<br/>des Réseaux</>}
                        img={"/image/offer/IconeSecuriteReseaux.png"}
                        options={[
                            "Accès direct à votre Chef de projet",
                            "RDV de pilotage semestriels",
                            "Suivi automatique des dernières vulnérabilités connues",
                            "Contrôle automatique de la sécurité de vos configurations",
                        ]}
                        logos={[
                            "/image/offer/IconeProfil.png",
                            "/image/offer/IconeAgenda.png",
                            "/image/offer/IconeLoupeEclair.png",
                            "/image/offer/IconeLoupeShield.png"
                        ]}
                    />
                </Grid>
                <Grid item xs={12} lg={6} xl={4} style={{marginTop: 20, marginBottom: 20}}>
                    <FlipComponent
                        title={<>Authentification<br/>Forte</>}
                        img={"/image/offer/IconeMFA2.png"}
                        options={[
                            "MFA pour :",
                            "> le VPN des nomades et des télétravailleurs;> les applications Cloud;> les serveurs et postes de travail",
                            "Compatible avec :",
                            "> Radius, LDAP, SAML, Web SDK, OIDC",
                            "Portail SSO pour simplifier les usages",
                        ]}
                        logos={[
                            "/image/offer/IconeProfils.png",
                            "",
                            "/image/offer/IconeHands.png",
                            "",
                            "",
                        ]}
                    />
                </Grid>
            </Grid>
        </PaperCustom>
    )
}

export default Offer